import React, { memo, useState, useEffect } from 'react';
import { Input, Form } from 'antd';
import { useSelector, useDispatch } from 'react-redux';

import actions from '@flux/action';
import InsightTextarea from '../insightTextarea';
import { insightModals } from '@model';
import { Button } from 'appkit-react';

import { splitCamelCaseString } from '@utils/widget';
import RichEditor from '@modules/questionnaires/complexity/richEditor';
import Draft from 'draft-js';

function PrincipleForm(props) {
  const {
    currentDetail = {},
    isEdit,
    from = '',
    category,
    segment,
    isActionLoading: isLoading,
    field = 'insight',
    companyInstance,
  } = props;
  const { changeConfig, closeModal, toggleActionLoading } = props;
  const defaultValue = isEdit ? currentDetail : {};
  const [canSubmit, setCanSubmit] = useState(false);
  const [contentTitle, setContentTitle] = useState(defaultValue.title);
  const [contentDesc, setContentDesc] = useState(defaultValue[field]);
  const [insightForm] = Form.useForm();
  const projectId = useSelector((state) => state.common.currentId);
  const dispatch = useDispatch();

  const shouldHideSummaryIfIsGuidingP = field === 'guidingPrinciple';

  const moduleName = splitCamelCaseString(field);

  const handleCancel = ({ needCallModalCallback = false }) => {
    if (from) {
      changeConfig({
        type: from,
      });
    } else {
      closeModal(needCallModalCallback);
    }
  };
  const handleEditFinish = (formData) => {
    if (isEdit && from !== '') {
      changeConfig({
        type: from,
        currentDetail: {
          ...currentDetail,
          ...formData,
        },
      });
    } else {
      handleCancel({ needCallModalCallback: true });
    }
  };
  const submitForm = async () => {
    // const value = await insightForm.validateFields();
    const value = {
      title: contentTitle,
      guidingPrinciple: contentDesc,
    };

    // console.log(value);

    const urlSuffix =
      field === 'guidingPrinciple' && companyInstance
        ? `?type=${companyInstance}`
        : '';
    toggleActionLoading(true);
    const result = await dispatch(
      actions.handleInsightModalSave({
        insightId: currentDetail.insightId,
        companyInstance,
        category,
        segment,
        isEdit,
        projectId,
        field,
        urlSuffix,
        ...value,
      }),
    );
    toggleActionLoading(false);

    if (result?.success) {
      handleEditFinish(value);
    }
  };

  const checkRichBlock = (richTextValue) => {
    if (typeof richTextValue == 'string') {
      try {
        richTextValue = JSON.parse(richTextValue);
      } catch (e) {
        console.log('JSON parse fail', e);
      }
    }
    if (typeof richTextValue === 'string') {
      return Boolean(richTextValue?.length);
    }
    if (
      typeof richTextValue === 'object' &&
      Object.keys(richTextValue).includes('blocks')
    ) {
      const draftState = Draft.convertFromRaw(richTextValue);
      return draftState.hasText();
    }
  };

  useEffect(() => {
    Object.keys(defaultValue).length === 0
      ? setCanSubmit(true)
      : setCanSubmit(false);
  }, []);

  return (
    <div className="analysis-insight-list">
      <div className="insight-modal-header">
        <div className="insight-modal-title">
          {isEdit ? 'Edit' : 'New'} {moduleName}
        </div>
      </div>
      <div className="insight-modal-content">
        <div className="label">title</div>
        <div className="gp-modal-title-edit">
          <RichEditor
            readOnly={false}
            onInitialContentChange={true}
            value={contentTitle}
            onChange={(e) => {
              setContentTitle(e);
              setCanSubmit(
                checkRichBlock(e)
                  ? false
                  : contentDesc
                  ? !checkRichBlock(contentDesc)
                  : true,
              );
            }}
            typeField={{
              underline: true,
              bold: true,
              italic: true,
              unordered_list: false,
              ordered_list: false,
              link: true,
              text_color: true,
            }}
          />
        </div>
        <div className="label">
          {shouldHideSummaryIfIsGuidingP ? 'description' : moduleName}
        </div>
        <div className="gp-modal-content-edit">
          <RichEditor
            readOnly={false}
            onInitialContentChange={true}
            value={contentDesc}
            onChange={(e) => {
              setContentDesc(e);
              setCanSubmit(
                checkRichBlock(e)
                  ? false
                  : contentTitle
                  ? !checkRichBlock(contentTitle)
                  : true,
              );
            }}
          />
        </div>
      </div>
      <div className="action-wrapper">
        <Button
          isLoading={isLoading}
          kind="secondary"
          size="lg"
          onClick={handleCancel}
        >
          Cancel
        </Button>
        <Button
          isLoading={isLoading}
          size="lg"
          onClick={submitForm}
          disabled={canSubmit}
        >
          Publish
        </Button>
      </div>
    </div>
  );
}

// InsightForm.propTypes = {};

export default memo(PrincipleForm);
